import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import Card from '@/components/common/Card'
import Input from '@/components/common/Input'
import Button from '@/components/common/Button'

function ParentForm({ teamId, parent, onSuccess, onCancel }) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [playerName, setPlayerName] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const isEditMode = !!parent

  useEffect(() => {
    if (parent) {
      setEmail(parent.email || '')
      setName(parent.name || '')
      setPlayerName(parent.player_name || '')
    }
  }, [parent])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      if (isEditMode) {
        // Update existing parent
        const { error: updateError } = await supabase
          .from('parents')
          .update({
            email: email.toLowerCase().trim(),
            name: name.trim() || null,
            player_name: playerName.trim() || null,
          })
          .eq('id', parent.id)
          .eq('team_id', teamId)

        if (updateError) throw updateError
      } else {
        // Insert new parent
        const { error: insertError } = await supabase
          .from('parents')
          .insert({
            team_id: teamId,
            email: email.toLowerCase().trim(),
            name: name.trim() || null,
            player_name: playerName.trim() || null,
          })

        if (insertError) {
          if (insertError.code === '23505') {
            throw new Error('This email is already added')
          }
          throw insertError
        }
      }

      onSuccess()
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <Card className="max-w-md w-full">
        <h2 className="font-heading text-2xl font-bold mb-4">
          {isEditMode ? 'Edit Parent' : 'Add Parent'}
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="email"
            label="Email"
            placeholder="parent@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />

          <Input
            label="Parent Name (Optional)"
            placeholder="John Smith"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={loading}
          />

          <Input
            label="Player Name (Optional)"
            placeholder="Alex Smith"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            disabled={loading}
          />

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="flex gap-3">
            <Button
              type="button"
              variant="secondary"
              onClick={onCancel}
              disabled={loading}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={loading}
              className="flex-1"
            >
              {loading ? (isEditMode ? 'Saving...' : 'Adding...') : (isEditMode ? 'Save Changes' : 'Add Parent')}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  )
}

export default ParentForm

